import {
  CButton,
  CCol,
  CForm,
  CInput,
  CLabel,
  CRow,
  CTextarea,
} from "@coreui/react";
import React, { useState } from "react";
import Auth from "src/auth";
import { useHistory } from "react-router-dom";
import { Paper } from "@mui/material";
import Modal from "@mui/material/Modal";
import { apiCall } from "src/_apiConfig/apiCall";
import { styled } from "@mui/system";

const LotListViewAgrement = (props) => {
  const { authenticated } = Auth();
  let history = useHistory();
  const [agreementextendopen, setagreementextendopen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [agreementextendLotId, setagreementextendLotId] = useState("");
  const [agreementextendLastDate, setagreementextendLastDate] = useState("");
  const [agreementextendComments, setagreementextendComments] = useState();
  const [agreementextendLotNo, setagreementextendLotNo] = useState("");
  const [agreementextendamount, setagreementextendamount] = useState("");
  const [
    agreementextendamountdescription,
    setagreementextendamountdescription,
  ] = useState("");
  const [is7dayextention, setis7dayextention] = useState(false);
  const [openRevoke, setOpenRevoke] = useState(false);
  const [revokeDate, setrevokeDate] = useState();
  const [revokeMsg, setrevokeMsg] = useState();
  // eslint-disable-next-line no-unused-vars
  const [paymentSlotId, setpaymentSlotId] = useState("");

  const Backdrop = styled("div")`
    z-index: -1;
    position: fixed;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
    -webkit-tap-highlight-color: transparent;
  `;
  const modalstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    borderRadius: "4px",
    fontSize: "1rem",
    padding: "2rem",
  };

  const handleOpenagreementextend7day = (
    lotid,
    lotNo,
    latdate,
    amout,
    amountdescription
  ) => {
    setagreementextendopen(true);
    setis7dayextention(true);
    setagreementextendLotId(lotid);
    setagreementextendLotNo(lotNo);
    setagreementextendLastDate(latdate);
    setagreementextendamount(amout);
    setagreementextendamountdescription(amountdescription);
  };

  const handleOpenAgreementSecondeEtention = (
    lotid,
    lotNo,
    latdate,
    amout,
    amountdescription
  ) => {
    setis7dayextention(false);
    setagreementextendopen(true);
    setagreementextendLotId(lotid);
    setagreementextendLotNo(lotNo);
    setagreementextendLastDate(latdate);
    setagreementextendamount(amout);
    setagreementextendamountdescription(amountdescription);
  };

  const HandlerAgreementPay = async () => {
    if (agreementextendComments === null || agreementextendComments === "") {
      alert("Please enter the comment");
    } else {
      history.push(
        `/SubmitAgreementExtend/${props.lotId}/${window.btoa(
          agreementextendComments
        )}/${is7dayextention}/${agreementextendamount}`,
        {
          from: window.location.href,
        }
      );
    }
  };

  // const handleOpenRevoke = (id) => {
  //   setpaymentSlotId(id);
  //   setOpenRevoke(true);
  // };

  const handleagreementextendclose = () => setagreementextendopen(false);

  const handleCloseRevoke = () => setOpenRevoke(false);

  const submitAgreementExtend7Day = async (e) => {
    e.preventDefault();
    handleCloseRevoke();
    props.setshowList(false);
    const header = new Headers();
    //  header.append("", "");

    const response = await apiCall(
      `LotDetails/RevokeLot?lotId=${props.decrypted}&msg=${revokeMsg}&paymentSlotId=${paymentSlotId}&newTeminationDate=${revokeDate}`,
      "PUT",
      header,
      null
    );
    await response.json();
    if (response.status === 200) {
      window.location.reload();
      props.setshowList(false);
      props.getLotDetails(true);
    }
  };

  const revokeLot = async (e) => {
    e.preventDefault();
    handleCloseRevoke();
    props.setshowList(false);
    const header = new Headers();
    //  header.append("", "");

    const response = await apiCall(
      `LotDetails/RevokeLot?lotId=${props.decrypted}&msg=${revokeMsg}&paymentSlotId=${paymentSlotId}&newTeminationDate=${revokeDate}`,
      "PUT",
      header,
      null
    );
    await response.json();
    if (response.status === 200) {
      window.location.reload();
      props.setshowList(false);
      props.getLotDetails(true);
    }
  };

  return (
    <>
      {authenticated.role === "Bidder" &&
        props.viewListDetails.lotTransferCount < 2 &&
        props.viewListDetails.actualQuantity !== 0 &&
        props.EmdPaid.isEMDPaid === false &&
        (props.viewTransferDetails.length === 0 ||
          (props.viewTransferDetails.length > 0 &&
            props.viewListDetails.isTransferFeePaidStatusSuccess === true)) && (
          <CRow className={"mt-2"}>
            <CCol xl={12}>
              <CButton
                className="mt-1 ml-1 mr-1"
                color="success"
                variant="outline"
                hidden={props.viewListDetails.DisableEMDPayment}
                disabled={
                  //props.viewListDetails.isDisableUploadDocumentForBidder ||
                  props.viewListDetails.DisableEMDPayment ||
                  props.viewListDetails.secondExtentionpaymentId > 0 ||
                  props.viewListDetails.day7PaymentId > 0 ||
                  props.viewListDetails.isLotLeftHOApproval === true
                    ? true
                    : false
                }
                onClick={() =>
                  handleOpenagreementextend7day(
                    props.viewListDetails.lotId,
                    props.viewListDetails.lotNo,
                    props.viewListDetails.bidderExtention7DayDate,
                    props.viewListDetails.day7Amount,
                    props.viewListDetails.day7AmountDescription
                  )
                }
              >
                Agrement Extend - 7Day
              </CButton>

              <CButton
                className="mt-1 ml-1 mr-1"
                color="success"
                variant="outline"
                disabled={
                  // props.viewListDetails.isDisableUploadDocumentForBidder ||
                  props.viewListDetails.DisableEMDPayment ||
                  props.viewListDetails.secondExtentionpaymentId > 0 ||
                  props.viewListDetails.isLotLeftHOApproval === true
                }
                onClick={() =>
                  handleOpenAgreementSecondeEtention(
                    props.viewListDetails.lotId,
                    props.viewListDetails.lotNo,
                    props.viewListDetails.bidderSecondExtentionDateTime,
                    props.viewListDetails.secondExtentionAmount,
                    props.viewListDetails.secondExtentionDescription
                  )
                }
              >
                Second Extention
              </CButton>
            </CCol>
          </CRow>
        )}

      {/* <CustomeModalPopup
        onOpen={agreementextendopen}
        onClose={handleagreementextendclose}
        onSubmitButton={submitAgreementExtend7Day}
        onCloseButton={handleagreementextendclose}
        body={
          <>
            <CRow>
              <CCol>
                <CLabel>LotNo: {agreementextendLotNo}</CLabel>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CLabel>Extention Date:</CLabel>
                <CLabel>{agreementextendLastDate}</CLabel>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CLabel>
                  Amount: {agreementextendamount}
                  {agreementextendamountdescription}
                </CLabel>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CLabel>Extention Comment:</CLabel>
                <CTextarea
                  rows="5"
                  onChange={(e) => setagreementextendComments(e.target.value)}
                  required
                />
              </CCol>
            </CRow>
          </>
        }
        isFromSubmit={true}
        isSubmitBtnDisabled={true}
        ButtonLoader={false}
        disabledBtn={isPaidActualGodownRent}
        btnSubmitText={"Add"}
        btnCloseText={"Close"}
      /> */}

      <Modal
        open={agreementextendopen}
        onClose={handleagreementextendclose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        BackdropComponent={Backdrop}
      >
        <Paper style={modalstyle} elevation={3}>
          <CForm
            className="needs-validation"
            onSubmit={submitAgreementExtend7Day}
          >
            <CRow>
              <CCol>
                <CLabel>LotNo: {agreementextendLotNo}</CLabel>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CLabel>Extention Date:</CLabel>
                <CLabel>{agreementextendLastDate}</CLabel>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CLabel>
                  Amount: {agreementextendamount}
                  {agreementextendamountdescription}
                </CLabel>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CLabel>Extention Comment:</CLabel>
                <CTextarea
                  rows="5"
                  onChange={(e) => setagreementextendComments(e.target.value)}
                  required
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol style={{ textAlign: "right" }}>
                <CButton
                  className="mt-3"
                  color="success"
                  onClick={() => HandlerAgreementPay()}
                >
                  Pay
                </CButton>
                <CButton
                  className="mt-3 ml-2 mr-2 btn-dark"
                  onClick={() => handleagreementextendclose()}
                >
                  Cancel
                </CButton>
              </CCol>
            </CRow>
          </CForm>
        </Paper>
      </Modal>

      <Modal
        open={openRevoke}
        onClose={handleCloseRevoke}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        BackdropComponent={Backdrop}
      >
        <Paper style={modalstyle} elevation={3}>
          <CForm className="needs-validation" onSubmit={revokeLot}>
            <CRow>
              <CCol>
                <CLabel>Reason to revoke:</CLabel>
                <CTextarea
                  onChange={(e) => setrevokeMsg(e.target.value)}
                  required
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CLabel>Date:</CLabel>
                <CInput
                  type="date"
                  onChange={(e) => setrevokeDate(e.target.value)}
                  required
                />
              </CCol>
            </CRow>
            <CRow
              style={{
                marginLeft: "7rem",
              }}
            >
              <CCol>
                <CButton className="mt-3" color="success" type="submit">
                  Revoke
                </CButton>
              </CCol>
            </CRow>
          </CForm>
        </Paper>
      </Modal>
    </>
  );
};

export default LotListViewAgrement;
